import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';

import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import { NibCardItem as CardItem } from '../NibCard';

function isInvalidDate(d) {
  return isNaN(Date.parse(d));
}

const InputDate = ({
  required = false,
  onChange = () => {},
  minDateMessage = 'Date should not be before minimal date',
  minDate,
  maxDate,
  maxDateMessage = 'Date should not be after maximal date',
  name,
  placeholder,
  label,
  helperText,
  tools = ['info'],
  onAdd = () => {},
  formik,
  dateTime = false,
  inputVariant = 'outlined',
  value = null,
  showToolbar = false,
  disabled = false,
  inputProps = {},
  clearable = false,
  allowKeyboardControl = true,
}) => {
  const [isHelper, toggleHelper] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const formikValue = formik.values[name];
  useEffect(() => {
    if (formikValue && !isInvalidDate(formikValue)) {
      const newDate = new Date(formikValue);
      setSelectedDate(newDate);
    }
    if (value && !isInvalidDate(value)) {
      const newDate = new Date(value);
      setSelectedDate(newDate);
    }
  }, [formikValue]);

  const fieldTouched = formik.touched[name];
  const handleBlur = () => {
    if (!fieldTouched) formik.setFieldTouched(name, true);
  };

  const handleDateChange = (date, val) => {
    handleBlur();

    if (date !== null && isInvalidDate(date)) return handleError('Invalid date');

    setSelectedDate(date);
    formik.setFieldValue(name, date);
    onChange(val);
  };

  const formikError = formik.errors[name];
  const handleError = (err) => {
    if (err) {
      formik.setFieldError(name, err);
    }
  };
  const dateComponentProps = {
    style: {
      width: '100%',
    },
    value: selectedDate,
    inputVariant,
    //inputSize: 'small',
    placeholder: placeholder ?? undefined,
    onChange: handleDateChange,
    onError: handleError,
    disabled,
    clearable,
    allowKeyboardControl,
    disableToolbar: !showToolbar && !dateTime,
    variant: 'dialog',
    format: dateTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy',
    margin: 'normal',
    KeyboardButtonProps: {
      'aria-label': 'change date',
    },
    inputProps: {
      ...inputProps,
    },
    onBlur: handleBlur,
    error: !!formikError && fieldTouched,
    helperText: fieldTouched ? formikError : '',
    ampm: false,
    DialogProps: {
      className: 'dateDialog',
    },
    ...(minDate
      ? {
          minDate: minDate ? new Date(minDate) : null,
          minDateMessage: minDateMessage,
        }
      : {}),
    ...(maxDate
      ? {
          maxDate: maxDate ? new Date(maxDate) : null,
          maxDateMessage: maxDateMessage,
        }
      : {}),
  };
  return (
    <CardItem name={`${label} ${required ? '*' : ''}`} btns={tools} onInfo={() => toggleHelper(!isHelper)}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justify-content="space-around">
          {dateTime ? (
            <KeyboardDateTimePicker {...dateComponentProps} helperText={isHelper && helperText} />
          ) : (
            <KeyboardDatePicker {...dateComponentProps} helperText={isHelper && helperText} />
          )}
        </Grid>
      </MuiPickersUtilsProvider>
    </CardItem>
  );
};

export default InputDate;
